import LevelingFrameworks from '../../shared/levelingFrameworks';
import { prepareLevelingFrameworksData } from '../../../utility/leveling';
import { isEmpty } from '../../../utility/validation';
import { FIELD_TYPES } from '../../../constants/fieldTypes';
import { LEVELING_TEMPLATES } from '../../../constants/levelingTemplates';
import { API_UNIQUE_FRAMEWORK } from '../../../constants/apiRoutes';
import { asyncDebounce, trimString } from '../../../utility/helpers';
import http from '../../../utility/http';

export const TEMPLATE_OPTIONS = [
  {
    id: 1,
    value: LEVELING_TEMPLATES.CARTA,
  },
  {
    id: 2,
    value: LEVELING_TEMPLATES.FACEBOOK,
  },
  {
    id: 3,
    value: LEVELING_TEMPLATES.AMAZON,
  },
];

export const getLevelingTemplateFormColumns = (
  templateSubtitle,
  renderDescription,
  renderAttributes,
  renderRange,
  renderPeople
) => [
  {
    id: 1,
    columnContentWrapperClass: 'columnContent',
    scrollYClass: 'scrollY',
    fields: [
      {
        name: 'template',
        type: FIELD_TYPES.SELECTABLE_LIST,
        options: TEMPLATE_OPTIONS,
        label: templateSubtitle,
        required: true,
        validators: [
          { type: 'required', validator: isEmpty },
          {
            type: 'isAlreadyChosen',
            validator: asyncDebounce(({ value }) => {
              const params = {
                name: trimString(value?.frameworks[0]?.name),
              };
              return http
                .get(API_UNIQUE_FRAMEWORK, { params })
                .then(({ data }) => !data);
            }, 300),
            async: true,
          },
        ],
      },
    ],
  },
  {
    id: 2,
    columnContentWrapperClass: 'previewColumnContent',
    fields: [
      {
        name: 'preview',
        type: FIELD_TYPES.PREVIEW,
        previewKey: 'template',
        isReadOnly: true,
        component: ({
          translations,
          data,
          isExpandedOnFirstOpen,
          isExpandedOnFirstOpenFramework,
          toggleExpansionFramework,
          toggleExpansion,
        }) => (
          <LevelingFrameworks
            translations={translations}
            levelingFrameworks={prepareLevelingFrameworksData(
              data,
              renderDescription,
              renderAttributes,
              renderRange,
              renderPeople
            )}
            isExpandedOnFirstOpen={isExpandedOnFirstOpen}
            toggleExpansion={toggleExpansion}
            isExpandedOnFirstOpenFramework={isExpandedOnFirstOpenFramework}
            toggleExpansionFramework={toggleExpansionFramework}
            isReadOnly
            canManageLeveling
          />
        ),
      },
    ],
  },
];

export const prepareAttributes = attributesWithQuestions => {
  return attributesWithQuestions.map(attribute => {
    return {
      ...attribute,
      [FIELD_TYPES.RANGE_FROM]: 0,
      [FIELD_TYPES.RANGE_TO]: 10,
    };
  });
};

export const prepareDataForSave = levelAttributes => {
  const { RANGE_FROM, RANGE_TO } = FIELD_TYPES;
  const attributesForSave = levelAttributes.reduce((acc, curr) => {
    return [
      ...acc,
      {
        attribute: curr.id,
        [RANGE_FROM]: curr[RANGE_FROM],
        [RANGE_TO]: curr[RANGE_TO],
      },
    ];
  }, []);

  return attributesForSave;
};

export const prepareTemplateForSave = framework => {
  return {
    name: framework.name,
    tracks: framework?.tracks?.map(track => {
      return {
        name: track.name,
        levels: track.levels?.map(level => {
          return {
            name: level.name,
            description: level.description,
          };
        }),
      };
    }),
  };
};

export const SALARY_FIELDS = [
  {
    name: 'min_salary',
    required: true,
    translationKey: 'minSalary',
    type: 'number',
    validators: [
      {
        validator: (value, values) =>
          values.max_salary ? isEmpty(value) : true,
        shouldPassFormValues: true,
        type: 'required',
      },
      {
        validator: value => value === null || value > 0,
        type: 'negativeSalary',
      },
      {
        validator: value => value <= 2147483647,
        type: 'exceeded',
      },
      {
        validator: (value, values) =>
          values.max_salary ? value <= values.max_salary : true,
        shouldPassFormValues: true,
        type: 'invalidMinSalary',
      },
    ],
  },
  {
    name: 'max_salary',
    required: true,
    translationKey: 'maxSalary',
    type: 'number',
    validators: [
      {
        validator: (value, values) =>
          values.min_salary ? isEmpty(value) : true,
        shouldPassFormValues: true,
        type: 'required',
      },
      {
        validator: value => value === null || value > 0,
        type: 'negativeSalary',
      },
      {
        validator: value => value <= 2147483647,
        type: 'exceeded',
      },
      {
        validator: (value, values) =>
          values.min_salary ? value >= values.min_salary : true,
        shouldPassFormValues: true,
        type: 'invalidMaxSalary',
      },
    ],
  },
];
